import { COMPANY, fmtMoney, MAX_DRIVE_HOURS_PER_DAY } from "./pricing";
import { MOWER_LABELS, esc } from "./rfp";

// Driver/dispatcher route sheet: route + schedule + equipment + driver bonus.
// No customer pricing or margins — this is an internal operations document.
export function buildRouteSheetHtml({
  pickup,
  drops,
  effectiveMiles,
  totalRouteHours,
  schedule,
  units,
  bonusAmount,
}) {
  const date = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const hours = Math.round((totalRouteHours || 0) * 10) / 10;
  const days = Math.max(1, Math.ceil((hours || 0) / MAX_DRIVE_HOURS_PER_DAY));

  const dropRows = (drops || [])
    .map(
      (d, i) => `<tr>
      <td style="text-align:center;font-weight:bold;">${i + 1}</td>
      <td>${esc(d.address)}</td>
      <td>${esc(d.customer || "-")}</td>
      <td>${d.phone ? `<a href="tel:${esc(d.phone)}">${esc(d.phone)}</a>` : "-"}</td>
      <td style="text-align:center;">${esc(d.eta || "TBD")}</td>
    </tr>`
    )
    .join("");

  const unitRows = (units || [])
    .map(
      (u, idx) => `<tr>
      <td>${idx + 1}</td>
      <td>${esc(MOWER_LABELS[u.type] || u.type || "-")}</td>
      <td>${esc(u.brand || "-")} ${esc(u.model || "")}</td>
      <td style="text-align:center">${esc(u.qty || 1)}</td>
      <td style="text-align:center">${esc(u.length || "-")} × ${esc(u.width || "-")} × ${esc(u.height || "-")} in</td>
      <td style="text-align:center">${esc(u.weight || "-")} lbs</td>
    </tr>`
    )
    .join("");

  const liftgate = [];
  if (schedule?.liftgatePickup) liftgate.push("Pickup");
  if (schedule?.liftgateDelivery) liftgate.push("Delivery");

  return `<!doctype html><html><head><meta charset="utf-8"/>
<title>K&G Driver Route Sheet</title>
<style>
  * { box-sizing:border-box; }
  body { font-family: Arial, Helvetica, sans-serif; color:#1C1917; margin:0; padding:40px; background:#fff; }
  .brandbar { background:#1C1917; color:#fff; padding:22px 26px; border-radius:10px; display:flex; justify-content:space-between; align-items:center; }
  .brandbar .meta { text-align:right; font-size:12px; color:#d6d3d1; line-height:1.5; }
  h2 { font-size:14px; text-transform:uppercase; letter-spacing:1px; color:#F97316; border-bottom:2px solid #F97316; padding-bottom:6px; margin:28px 0 12px; }
  table { width:100%; border-collapse:collapse; font-size:12px; }
  th { background:#1C1917; color:#fff; text-align:left; padding:8px; font-size:11px; text-transform:uppercase; }
  td { border:1px solid #E7E5E4; padding:8px; }
  ul { margin:6px 0; padding-left:20px; font-size:13px; line-height:1.7; }
  .bonus { margin-top:22px; padding:14px 16px; background:#F0FDF4; border:1px solid #16A34A; border-radius:8px; font-size:14px; }
  .bonus b { color:#16A34A; }
  .muted { color:#57534E; font-size:12px; }
  @media print { body { padding:14px; } .brandbar { -webkit-print-color-adjust:exact; print-color-adjust:exact; } th{ -webkit-print-color-adjust:exact; print-color-adjust:exact; } }
</style></head>
<body>
  <div class="brandbar">
    <div>
      <img src="${window.location.origin}/kg-logo.png" alt="K&amp;G Mowers + Tractors" style="height:54px;display:block;" />
      <div style="font-size:12px;color:#F97316;margin-top:8px;font-weight:bold;">Driver Route Sheet</div>
    </div>
    <div class="meta">
      <div><b style="color:#fff;">${esc(COMPANY.name)}</b></div>
      <div>${esc(COMPANY.address)}</div>
      <div>${esc(COMPANY.phone)}</div>
      <div>${esc(date)}</div>
    </div>
  </div>

  <h2>Route</h2>
  <ul>
    <li><b>Pickup:</b> ${esc(pickup)}</li>
    <li><b>Round trip:</b> ${esc(effectiveMiles || 0)} miles · ~${esc(hours)} hrs → <b>${days} driving day${days > 1 ? "s" : ""}</b> (${MAX_DRIVE_HOURS_PER_DAY}h/day max)</li>
  </ul>
  <table>
    <thead><tr><th style="width:34px;">#</th><th>Delivery address</th><th>Customer</th><th>Phone</th><th style="width:96px;">Est. delivery</th></tr></thead>
    <tbody>${dropRows || `<tr><td colspan="5" class="muted">No delivery stops entered</td></tr>`}</tbody>
  </table>

  <h2>Schedule &amp; Requirements</h2>
  <ul>
    <li><b>Pickup date:</b> ${esc(schedule?.pickupDate || "TBD")}</li>
    <li><b>Delivery date:</b> ${esc(schedule?.deliveryDate || "TBD")}</li>
    <li><b>Liftgate required:</b> ${liftgate.length ? esc(liftgate.join(" & ")) : "None"}</li>
  </ul>

  <h2>Equipment to Load</h2>
  <table>
    <thead><tr><th>#</th><th>Type</th><th>Brand / Model</th><th>Qty</th><th>Dimensions (L×W×H)</th><th>Weight</th></tr></thead>
    <tbody>${unitRows || `<tr><td colspan="6" class="muted">No units entered</td></tr>`}</tbody>
  </table>

  ${Number(bonusAmount) > 0 ? `<div class="bonus">Driver bonus for this trip: <b>${fmtMoney(Number(bonusAmount))}</b></div>` : ""}

  <p class="muted" style="margin-top:22px;">Questions on this route? Call dispatch at ${esc(COMPANY.phone)}.</p>
</body></html>`;
}
